import { Controller } from '@hotwired/stimulus';

// LRPO-5463 — the Export PDF link is a native (turbo:false) binary download:
// #export_pdf streams the PDF with Content-Disposition: attachment, so the page
// never navigates and the server has no HTML response on which to render a
// success flash. Confirm the action client-side instead by dropping a
// dismissible Bootstrap alert into the page-level #reports_overview_flash slot
// the Reports surfaces already carry (the same slot ReportTemplatesController
// and the ROI scenario CRUD actions target) — so generating a PDF gets the same
// visible confirmation every other ROI action now shows.
//
// values:
//   message — the confirmation copy (defaults to a generating-PDF message)
//   target  — id of the flash slot to write into (defaults to the reports slot)
export default class extends Controller {
  static values = {
    message: {
      type: String,
      default: 'Generating your ROI PDF — your download will begin shortly.'
    },
    target: { type: String, default: 'reports_overview_flash' }
  };

  notify() {
    const slot = document.getElementById(this.targetValue);
    if (!slot) return;

    const alert = document.createElement('div');
    alert.className =
      'alert alert-success alert-dismissible fade show shadow-sm mb-3';
    alert.setAttribute('role', 'status');
    alert.setAttribute('aria-live', 'polite');
    alert.textContent = this.messageValue;

    const close = document.createElement('button');
    close.type = 'button';
    close.className = 'btn-close';
    close.setAttribute('data-bs-dismiss', 'alert');
    close.setAttribute('aria-label', 'Close');
    alert.appendChild(close);

    // Replace rather than append so repeated clicks don't stack toasts.
    slot.replaceChildren(alert);
  }
}
